import { Fragment } from 'react';
import Meta from './../components/Meta';
import FloorMap from './../components/FloorMap';

function FutureFair2026Page() {
  return (
    <Fragment>
      <Meta title="Future Fair 2026 — Floor Map" />
      <div className="flex h-[calc(100dvh-6rem)] min-h-0 max-h-[calc(100dvh-6rem)] flex-col overflow-hidden">
        <FloorMap />
      </div>
    </Fragment>
  );
}

export default FutureFair2026Page;
